import { Component, Input } from '@angular/core';
import { ApplicationData } from '../../application/application.model';

@Component({
    selector: 'ifp-application-summary',
    templateUrl: './application-summary.component.html',
    styleUrls: ['./application-summary.component.scss'],
    standalone: false
})
export class ApplicationSummaryComponent {

  @Input() application: ApplicationData;
}
